import Animated from 'animated/lib/targets/react-dom'
import injectDependencies from './InteractableView'
import AnimatedView from './AnimatedView'
import PanResponder from "./panresponder";

// Fake the Animated.View component
Animated.View = AnimatedView

let Interactable = injectDependencies( Animated, PanResponder ) 
export default {View: Interactable}